<template>

  <div class="mt-4">
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-light" role="status"></div>
      <p>Cargando...</p>
    </div>
    <!-- Page Header -->
    <div class="page-header">
      <h1 class="page-header-title"><i class="bi bi-truck me-2"></i>Listado de Envíos Provincia — Mercadería</h1>
    </div>

    <!-- Filtros -->
    <div class="filter-card">
      <div class="row g-2">
        <div class="col-md-2 d-none d-md-block">
          <label class="form-label">RUC</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.ruc" placeholder="Ingrese RUC" />
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">Razón Social</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.razon_social" placeholder="Razón social..." />
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">Cliente Final</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.cliente_final" placeholder="Cliente final..." />
        </div>
        <div class="col-md-2 d-none d-md-block">
          <label class="form-label">N° Pedido</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.pedido" placeholder="N° Pedido" />
        </div>
        <div class="col-md-2 d-none d-md-block">
          <label class="form-label">N° Orden Compra</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.orden_compra" placeholder="N° Orden" />
        </div>
        <div class="col-12 col-md-2">
          <label class="form-label">N° Guía</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.guia" placeholder="N° Guía" />
        </div>
        <div class="col-md-2 d-none d-md-block">
          <label class="form-label">Serie de Guía</label>
          <input type="text" class="form-control form-control-sm" v-model="filtros.serie_guia" placeholder="Ej: T012" />
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">Rango de Fechas</label>
          <div class="row gx-1">
            <div class="col-6"><input type="date" class="form-control form-control-sm" v-model="filtros.fecha_inicio" /></div>
            <div class="col-6"><input type="date" class="form-control form-control-sm" v-model="filtros.fecha_fin" /></div>
          </div>
        </div>
        <div class="col-md-3 d-none d-md-block">
          <label class="form-label">Estado</label>
          <select class="form-select form-select-sm" v-model="filtros.id_estados_envio">
            <option value="">Todos</option>
            <option v-for="item in estadosEnvio" :value="item.id" :key="item.id">{{ item.nombre }}</option>
          </select>
        </div>
        <div class="col-md-2 d-none d-md-block" v-if="esSuperAdmin()">
          <label class="form-label">Modalidad</label>
          <select class="form-select form-select-sm" v-model="filtros.id_modalidades_envio">
            <option value="">Todos</option>
            <option value="2">CONSOLIDADO</option>
            <option value="3">EXCLUSIVO</option>
            <option value="4">AEREO</option>
          </select>
        </div>
        <!-- Los botones se ubican en la última fila de filtros si hay espacio (una fila menos) -->
        <div class="col-12 col-md-auto ms-auto d-flex justify-content-end align-items-end">
          <div class="filter-actions">
            <button class="btn-filter" @click="aplicarFiltros"><i class="bi bi-search"></i> Buscar</button>
            <button class="btn-clear" @click="limpiarFiltros()"><i class="bi bi-x-circle"></i> Limpiar</button>
            <button class="btn-export" @click="exportarExcel"><i class="bi bi-file-earmark-excel"></i> Exportar</button>
            <button class="btn-pdf" @click="exportarReportePdf" title="Programación de la ruta: hasta 3 días"><i class="bi bi-file-earmark-pdf"></i> Ruta</button>
          </div>
        </div>
      </div>
    </div>


  <!-- VERSIÓN TABLA (solo escritorio y tablets grandes) -->
  <div class="table-responsive mt-4 d-none d-md-block">
    <table id="table-listado" class="table table-sm table-bordered table-hover align-middle table-merc-list">
      <thead>
        <tr>
          <th>Rastreo</th>
          <th>F. Salida</th>
          <th>F. Entrega</th>
          <th>N° Guía</th>
          <th>N° Pedido</th>
          <th>N° Factura</th>
          <th>Orden Compra</th>
          <th>Remitente</th>
          <th>Destinatario</th>
          <th>Estado</th>
          <th class="col-acciones">Acciones</th>
        </tr>
      </thead>
      <tbody style="font-size:0.8rem;">
        <tr v-for="(envio, index) in envios" :key="index">
          <td class="text-nowrap">
            <a :href="`/tracking?numeroRastreo=${envio.rastreo}`" class="fw-semibold text-primary">{{ envio.rastreo }}</a>
          </td>
          <td class="celda-id">{{ formatFecha(envio.fecha_salida) }}</td>
          <td class="celda-id">{{ formatFecha(envio.fecha_entrada_maxima) }}</td>
          <td class="celda-guia">{{ (envio.documentos && envio.documentos.length > 1) ? 'VARIAS' : envio.guias_concatenadas }}</td>
          <td>{{ (envio.documentos && envio.documentos.length > 1) ? 'VARIOS' : envio.pedidos_concatenados }}</td>
          <td>{{ (envio.documentos && envio.documentos.length > 1) ? 'VARIAS' : envio.facturas_concatenadas }}</td>
          <td>{{ (envio.documentos && envio.documentos.length > 1) ? 'VARIAS OC' : envio.oc_concatenadas }}</td>
          <td class="celda-entidad">
            <div class="celda-dato">{{ envio.ruc_remitente }}</div>
            <div class="entidad-nombre" :title="envio.empresa_sucursal">{{ envio.empresa_sucursal }}</div>
            <div class="celda-dato">{{ envio.ubicacion_remitente }}</div>
          </td>
          <td class="celda-entidad">
            <div class="celda-dato">{{ envio.ruc_destinatario }}</div>
            <div class="entidad-nombre" :title="envio.empresa_sucursal_destino">{{ envio.empresa_sucursal_destino }}</div>
            <div class="celda-dato">{{ envio.ubicacion_destinatario }}</div>
          </td>
          <td class="text-center p-1">
            <span :class="getBadgeClass(envio.id_estados_envio)" @click="openEstadoEnvio(envio)" style="cursor:pointer; white-space:normal; word-break:break-word;">
              {{ envio.estado_envio }}
            </span>
          </td>
          <td class="col-acciones">
            <div class="btn-group">
              <button class="btn-acciones dropdown-toggle" type="button" title="Acciones" aria-label="Acciones" data-bs-toggle="dropdown">
                <i class="bi bi-three-dots-vertical"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end custom-dropdown">
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="mostrarDetalle(envio)">
                    <i class="bi bi-search text-dark"></i> Mostrar detalles
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="editarEnvio(envio)">
                    <i class="bi bi-pencil text-dark"></i> Editar envío
                  </a>
                </li>
                <li v-if="esSuperAdmin()">
                  <a class="dropdown-item" href="#" @click.prevent="abrirGestionarModal(envio)">
                    <i class="bi bi-list-task text-dark"></i> Gestionar
                  </a>
                </li>
                <li v-if="esSuperAdmin()">
                  <a class="dropdown-item" href="#" @click.prevent="abrirCargarArchivosModal(envio)">
                    <i class="bi bi-upload text-dark"></i> Documentos
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="abrirGestionGuiasModal(envio)">
                    <i class="bi bi-file-text text-dark"></i> Gestión de Guías
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="eliminarEnvio(envio)">
                    <i class="bi bi-trash text-danger"></i> Eliminar
                  </a>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- VERSIÓN CARD (solo móviles) -->
  <div class="d-block d-md-none mt-3">
    <div v-for="(envio, index) in envios" :key="index" class="card shadow-sm mb-3 border-0">
      <div class="card-body p-3">
        <div @click.prevent="mostrarDetalle(envio)">
          <h6 class="card-title fw-bold text-primary mb-2">
            Rastreo: <a :href="`/tracking?numeroRastreo=${envio.rastreo}`">{{ envio.rastreo }}</a>
          </h6>
          <p class="mb-1"><strong>Fecha Salida:</strong> {{ formatFecha(envio.fecha_salida) }}</p>
          <p class="mb-1"><strong>Fecha Entrega:</strong> {{ formatFecha(envio.fecha_entrada_maxima) }}</p>
          <p class="mb-1"><strong>N° Guía:</strong> {{ envio.documentos.length > 1 ? 'VARIAS GUÍAS' : envio.guias_concatenadas
            }}</p>
          <p class="mb-1"><strong>Destino:</strong> {{ envio.ubicacion_destinatario }}</p>
          <p class="mb-1"><strong>Remitente:</strong> {{ envio.empresa_sucursal }} ({{ envio.ubicacion_remitente }})</p>
          <p class="mb-1"><strong>Destinatario:</strong> {{ envio.empresa_sucursal_destino }} ({{ envio.ubicacion_destinatario }}) </p>
        </div>
        <p class="mb-1"><strong>Estado:</strong>
          <span :class="getBadgeClass(envio.id_estados_envio)" class="mx-2" @click="openEstadoEnvio(envio)">
            {{ envio.estado_envio }}
          </span>
        </p>
        <div class="btn-group w-100 mt-2">
          <button class="btn btn-outline-dark btn-sm dropdown-toggle w-100" type="button" data-bs-toggle="dropdown">
            <i class="bi bi-three-dots-vertical"></i> Opciones
          </button>
          <ul class="dropdown-menu w-100">
            <li>
              <a class="dropdown-item" href="#" @click.prevent="mostrarDetalle(envio)">
                <i class="bi bi-search text-dark"></i> Mostrar detalles
              </a>
            </li>
            <li v-if="esSuperAdmin()">
              <a class="dropdown-item" href="#" @click.prevent="abrirGestionarModal(envio)">
                <i class="bi bi-file-text text-dark"></i> Gestionar
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="#" @click.prevent="abrirGestionGuiasModal(envio)">
                <i class="bi bi-file-text text-dark"></i> Gestión de Guías
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Paginación (25 por página, viene paginado desde el backend) -->
  <PaginacionListado :pagina="pagina" :total-paginas="totalPaginas" :total="totalEnvios" :por-pagina="porPagina"
    :en-pagina="envios.length" :cargando="isLoading" etiqueta="envíos" @cambiar="cambiarPagina" />


  <div v-if="modalGestionANW" id="modalGestionANW" class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content shadow-lg border-0">
        <!-- Encabezado -->
        <div class="modal-header">
          <h5 class="modal-title">Gestión del Envío</h5>
          <button type="button" class="btn-close" @click="modalGestionANW = false"></button>
        </div>
        <div class="modal-body p-4">
          <div class="mb-4">
            <ShippingANW ref="shippingANWRef" :envio="detalleEnvio"></ShippingANW>
          </div>
          <div class="mt-3 d-flex justify-content-end mb-3"><button @click="guardarGestion()" type="submit"
              class="btn btn-primary d-flex align-items-center gap-2"><i class="bi bi-floppy"></i> Guardar </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalDetalleEnvio v-if="modalDetalle" :show="modalDetalle" :envio="detalleEnvio" @close="cerrarDetalle" />

  <!-- Modal para subir archivos -->
  <ModalArchivos v-if="showModalArchivos" :show="showModalArchivos" :archivos="archivos"
    @close="showModalArchivos = false" @ver="verArchivo" @eliminar="eliminarArchivo" />

  <div v-if="modalEstados" class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="uploadModalLabel">Gestión de Estados</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="modalEstados = false"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <label for="">Estado del Envío</label>
              <select name="" id="" class="form-control" v-model="nuevoEstado" :disabled="isUpdatingEstado">
                <option v-for="item in estadosEnvio" :value="item.id" :key="item.id">{{ item.nombre }}</option>
              </select>
            </div>
          </div>
          <div class="row mt-2">
            
            <div class="form-group mt-2" v-if="nuevoEstado == 19">
                <label for="tipoArchivo">Conformidad de Draeger (N°hojas)</label>
                <select v-model="conformidad_draeger" class="form-control" id="tipoArchivo">
                  <option value="SIN RECEPCIONAR">SIN RECEPCIONAR</option>
                  <option value="RECEPCIONADO">RECEPCIONADO</option>
                  <option value="OBSERVADO">OBSERVADO</option>
                </select>
              </div>

              <!-- Bultos en Origen: 1er Recojo Finalizado (4) o 2do Recojo Finalizado (6) -->
              <div v-if="nuevoEstado == 4 || nuevoEstado == 6" class="row mt-2">
                <div class="col-md-12">
                  <label class="form-label">Cantidad de Bultos en Origen</label>
                  <input type="number" v-model="cantidad_bultos_origen" class="form-control" />
                </div>
                <div class="col-md-12 mt-2">
                  <label class="form-label">Estado de los Bultos en Origen</label>
                  <select v-model="estado_bultos_origen" class="form-control">
                    <option disabled value="">Seleccione un estado</option>
                    <option>SIN DAÑO</option>
                    <option>CON DAÑO</option>
                  </select>
                </div>
              </div>

              <!-- Bultos en Destino: Entregado (11) -->
              <div v-if="nuevoEstado == 11" class="row mt-2">
                <div class="col-md-12">
                  <label class="form-label">Cantidad de Bultos en Destino</label>
                  <input type="number" v-model="cantidad_bultos_destino" class="form-control" />
                </div>
                <div class="col-md-12 mt-2">
                  <label class="form-label">Estado de los Bultos en Destino</label>
                  <select v-model="estado_bultos_destino" class="form-control">
                    <option disabled value="">Seleccione un estado</option>
                    <option>SIN DAÑO</option>
                    <option>CON DAÑO</option>
                  </select>
                </div>
              </div>
              <div v-if="nuevoEstado == 11" class="row mt-2">
                <div class="col-md-12">
                  <label class="form-label">Conformidad de la entrega</label>
                  <select v-model="conformidad_entrega" class="form-control">
                    <option disabled value="">Seleccione un estado</option>
                    <option>ACEPTADO</option>
                    <option>RECHAZADO</option>
                    <option>EN CUSTODIA</option>
                    <option>CANCELADO</option>
                  </select>
                </div>
              </div>

            <div v-if="nuevoEstado != 19 && nuevoEstado != 12"  class="form-group">
              <label for="tipoArchivo">Tipo de Archivo</label>
              <select v-model="tipoArchivo" class="form-control" id="tipoArchivo">
                <option value="">-- Selecciona un tipo --</option>
                <option value="fotos">📸 Fotos (JPG / PNG)</option>
                <option value="videos">🎥 Videos (MP4 / MOV / AVI)</option>
                <option value="pdf">📄 PDF (escaneo o foto en PDF)</option>
              </select>
            </div>
            <div v-if="nuevoEstado != 19 && nuevoEstado != 12" class="form-group mt-2">
              <label for="archivo">¿Qué archivo?</label>
              <select v-model="nuevoArchivo.tipo" class="form-control" id="archivo">
                <option value="">-- Selecciona un archivo --</option>
                <option v-for="(opcion, index) in opcionesFiltradas" :key="index" :value="opcion">
                  {{ opcion }}
                </option>
              </select>
            </div>
            <div v-if="nuevoEstado != 19 && nuevoEstado != 12" class="col-md-12">
              <label class="form-label">Comentario</label>
              <textarea v-model="nuevoArchivo.comentario" class="form-control" rows="2"></textarea>
            </div>
          </div>

          <!-- Drag & Drop Zone -->
          <div v-if="nuevoEstado != 19 && nuevoEstado != 12" class="dropzone mt-3" @dragover.prevent="dragging = true" @dragleave.prevent="dragging = false"
            @drop.prevent="soltarArchivo" @click="abrirExplorador">
            <div v-if="!nuevoArchivo.nombre" class="dropzone-content">
              <i class="fas fa-cloud-upload-alt fa-3x"></i>
              <p>Arrastra un archivo aquí o haz clic para seleccionar</p>
              <input type="file" class="d-none" ref="fileInput" @change="seleccionarArchivo" />
            </div>
            <div v-else class="dropzone-preview">
              <img v-if="esImagen(nuevoArchivo.nombre)" :src="nuevoArchivo.url" class="img-thumbnail" width="100" />
              <p>{{ nuevoArchivo.nombre }}</p>
            </div>
          </div>
          <div v-if="nuevoEstado == 12">
              <p class="p-3 text-danger">AHORA SUBE TU CARGO ESCANEADO POR GESTIÓN DE GUIAS</p>
            </div>
          <br>
          <button @click="gestionEstado()" class="btn btn-primary btn-sm float-end" :disabled="isUpdatingEstado">
            {{ isUpdatingEstado ? 'Actualizando...' : 'Actualizar Estado' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Gestión de Guías -->
  <div v-if="showModalGestionGuias" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <!-- xl: la tabla tiene 7 columnas; scrollable para envíos con muchos documentos -->
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><i class="bi bi-file-earmark-text me-2"></i>Gestión de Guías</h5>
          <button type="button" class="btn-close" @click="showModalGestionGuias = false"></button>
        </div>
        <div class="modal-body">
          <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
            <span class="text-muted small">Envío</span>
            <span class="badge bg-primary fs-6 fw-semibold">{{ envioSeleccionadoGuias?.rastreo }}</span>
            <span v-if="envioSeleccionadoGuias?.documentos?.length" class="badge bg-light text-dark border">
              {{ envioSeleccionadoGuias.documentos.length }} {{ envioSeleccionadoGuias.documentos.length === 1 ? 'documento' : 'documentos' }}
            </span>
          </div>
          <div v-if="envioSeleccionadoGuias && envioSeleccionadoGuias.documentos && envioSeleccionadoGuias.documentos.length">

            <!-- Tabla desktop -->
            <div class="d-none d-md-block table-responsive">
              <table class="table table-bordered table-sm table-hover align-middle">
                <thead class="table-primary text-center" style="font-size:0.82rem;">
                  <tr>
                    <th>Guía Remitente</th>
                    <th>Guía Transportista</th>
                    <th>N° Pedido</th>
                    <th>Orden Compra</th>
                    <th>Factura</th>
                    <th>Docs. Extras</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody style="font-size:0.85rem;">
                  <tr v-for="detalle in envioSeleccionadoGuias.documentos" :key="detalle.id">
                    <td>{{ detalle.guia_remitente || '-' }}</td>
                    <td>{{ detalle.guia_transportista || '-' }}</td>
                    <td>{{ detalle.nro_pedido || '-' }}</td>
                    <td>{{ detalle.orden_compra || '-' }}</td>
                    <td>{{ detalle.numero_factura || '-' }}</td>
                    <td>{{ detalle.documentos_extras || '-' }}</td>
                    <td class="text-center" style="white-space:nowrap; width:90px;">
                      <button v-if="detalle.archivo_url" class="btn btn-sm btn-info me-1" @click="verArchivoGuia(detalle.archivo_url)" title="Ver archivo">
                        <i class="bi bi-eye"></i>
                      </button>
                      <button v-if="esSuperAdminOInterno()" class="btn btn-sm btn-primary" @click="subirArchivoGuia(detalle)" title="Subir archivo">
                        <i class="bi bi-upload"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Cards móvil -->
            <div class="d-block d-md-none">
              <div v-for="(detalle, i) in envioSeleccionadoGuias.documentos" :key="detalle.id"
                class="card mb-3 border" style="border-color:#c5cae9!important; border-radius:10px; overflow:hidden;">
                <div class="card-header py-2 d-flex justify-content-between align-items-center"
                  style="background:#3f51b5!important; color:#fff!important; border-bottom:none;">
                  <span class="fw-semibold small">Documento #{{ i + 1 }}</span>
                  <span v-if="detalle.guia_transportista"
                    class="badge fw-normal px-2 py-1"
                    style="background:rgba(255,255,255,0.25)!important; color:#fff!important; font-size:0.78rem;">
                    {{ detalle.guia_transportista }}
                  </span>
                </div>
                <div class="card-body py-3 px-3" style="background:#f8f9ff;">
                  <div class="row g-2" style="font-size:0.85rem;">
                    <div class="col-6">
                      <div class="text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.4px;">Guía Remitente</div>
                      <div class="fw-semibold text-dark">{{ detalle.guia_remitente || '—' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.4px;">N° Pedido</div>
                      <div class="fw-semibold text-dark">{{ detalle.nro_pedido || '—' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.4px;">Orden Compra</div>
                      <div class="fw-semibold text-dark">{{ detalle.orden_compra || '—' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.4px;">Factura</div>
                      <div class="fw-semibold text-dark">{{ detalle.numero_factura || '—' }}</div>
                    </div>
                    <div class="col-12" v-if="detalle.documentos_extras">
                      <div class="text-muted" style="font-size:0.72rem; text-transform:uppercase; letter-spacing:.4px;">Docs. Extras</div>
                      <div class="fw-semibold text-dark">{{ detalle.documentos_extras }}</div>
                    </div>
                  </div>
                </div>
                <div class="card-footer py-2 d-flex gap-2" style="background:#eef0fb!important; border-top:1px solid #c5cae9!important; color:inherit!important; font-weight:normal!important; padding:8px 12px!important;">
                  <button v-if="detalle.archivo_url" class="btn btn-sm flex-fill"
                    style="background:#0097a7; color:#fff; border:none;"
                    @click="verArchivoGuia(detalle.archivo_url)">
                    <i class="bi bi-eye me-1"></i>Ver archivo
                  </button>
                  <button v-if="esSuperAdminOInterno()" class="btn btn-sm flex-fill"
                    style="background:#3f51b5; color:#fff; border:none;"
                    @click="subirArchivoGuia(detalle)">
                    <i class="bi bi-upload me-1"></i>Subir archivo
                  </button>
                </div>
              </div>
            </div>

          </div>
          <div v-else class="text-muted text-center py-3">No hay detalles de guías para este envío.</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal para Subir Archivos de Guía -->
  <div v-if="showModalArchivoGuia" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><i class="bi bi-cloud-arrow-up me-2"></i>Subir archivo del documento</h5>
          <button type="button" class="btn-close" @click="cerrarModalArchivoGuia"></button>
        </div>
        <div class="modal-body">
          <!-- Datos del documento: solo los que tiene -->
          <div v-if="detalleGuiaSeleccionado && referenciasGuia(detalleGuiaSeleccionado).length" class="guia-refs">
            <div v-for="ref in referenciasGuia(detalleGuiaSeleccionado)" :key="ref.label" class="guia-ref">
              <span class="guia-ref-label">{{ ref.label }}</span>
              <span class="guia-ref-valor">{{ ref.valor }}</span>
            </div>
          </div>
          <!-- El tipo de archivo es fijo: se muestra como dato, no como select bloqueado -->
          <div class="guia-tipo">
            <i class="bi bi-file-earmark-pdf"></i>
            <div>
              <div class="guia-tipo-nombre">{{ archivoGuia.tipo }}</div>
              <div class="guia-tipo-detalle">PDF (escaneo o foto en PDF)</div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12">
              <label class="form-label">Comentario <span class="guia-opcional">(opcional)</span></label>
              <textarea v-model="archivoGuia.comentario" class="form-control" rows="2"
                placeholder="Algún detalle sobre el archivo"></textarea>
            </div>
          </div>

          <div class="dropzone mt-3" :class="{ 'drop-hover': draggingGuia }" @dragover.prevent="draggingGuia = true"
            @dragleave.prevent="draggingGuia = false" @drop.prevent="soltarArchivoGuia" @click="abrirExploradorGuia">
            <div v-if="!archivoGuia.nombre" class="dropzone-content">
              <i class="fas fa-cloud-upload-alt fa-3x"></i>
              <p>Arrastra un archivo aquí o haz clic para seleccionar</p>
              <input type="file" class="d-none" ref="fileInputGuia" @change="seleccionarArchivoGuia" />
            </div>
            <div v-else class="dropzone-preview">
              <img v-if="esImagen(archivoGuia.nombre)" :src="archivoGuia.url" class="img-thumbnail" width="100" />
              <p><strong>{{ archivoGuia.nombre }}</strong></p>
              <button class="btn btn-sm btn-outline-secondary mt-2" @click.stop="limpiarArchivoGuia">
                <i class="bi bi-x-circle"></i> Cambiar archivo
              </button>
            </div>
          </div>

          <p v-if="!archivoGuia.archivo" class="guia-hint">Selecciona el archivo para poder subirlo.</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="cerrarModalArchivoGuia" :disabled="loadingSubirArchivoGuia">Cancelar</button>
          <button class="btn btn-primary" @click="guardarArchivoGuia" :disabled="!archivoGuia.archivo || loadingSubirArchivoGuia">
            <i class="bi bi-upload me-1"></i> Subir archivo
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>

</template>

<script>
import ShippingANW from '@/components/ShippingANW.vue'
import ModalDetalleEnvio from '@/components/ModalDetalleEnvio.vue'
import ModalArchivos from '@/components/ModalArchivos.vue'
import PaginacionListado from '@/components/PaginacionListado.vue'

import axios from 'axios'
import Swal from 'sweetalert2'
import { validarRangoFechas, LIMITE_REPORTE_RUTA, mensajeErrorDescarga } from '@/utils/rangoFechas'

export default {
  name: 'ShippingListPage',
  components: { ShippingANW, ModalDetalleEnvio, ModalArchivos, PaginacionListado },
  data() {
    return {
      nuevoEstado:'',
      isLoading: true,
      tipoEnvio: this.$route.params.tipo_envio,
      modalDetalle: false,
      modalGestionANW: false,
      showModalArchivos: false,
      modalEstados: false,
      nombrePaquete: "",
      alto: "",
      ancho: "",
      largo: "",
      costoPorKg: "",
      pesoVolumetrico: "",
      pesoReal: "",
      costoPaquete: "",
      envioId: null,
      paquetes: [],
      estadosEnvio: [],
      causasConfomidad: [],
      causasEntregaCompleta: [],
      causasRetornoDocumentario: [
        { "id": 1, "nombre": "NINGUNO" },
        { "id": 2, "nombre": "DEMORA POR ANW" },
        { "id": 3, "nombre": "DEMORA POR CASO FORTUITO" },
        { "id": 4, "nombre": "DEMORA POR EL CLIENTE DE DRAEGER" }
      ]
      ,
      causasLlegadaDestino: [
        {
          "id": 1,
          "nombre": "NINGUNO"
        },
        {
          "id": 2,
          "nombre": "DEMORA POR CASO FORTUITO"
        },
        {
          "id": 3,
          "nombre": "DEMORA POR ANW"
        },
        {
          "id": 4,
          "nombre": "DEMORA POR CLIENTE DE DRAEGER"
        },
        {
          "id": 5,
          "nombre": "DEMORA POR DRAEGER"
        }
      ]
      ,
      formGestion: {
        guia_transporista: "",
        lead_time_prometido_cargos: "4 HORAS",
        lead_time_prometido_retorno: "5 DÍAS"
      },
      tipoArchivo: '',
      archivoSeleccionado: '',
      opciones: {
        fotos: [
          'Foto de mercadería en origen',
          'Foto del punto de recojo (opcional, para incidentes o validación)',
          'Foto de mercadería en el cliente',
          'Foto de bultos dañados (si aplica)',
          'Foto del cargo entregado en oficina (DRAEGER)',
          'Foto de acceso bloqueado o incidente en ruta',
          'Foto del tráfico o desvíos durante tránsito',
          'Foto de rechazo (cuando el cliente no acepta la entrega)',
          'Otros'
        ],
        videos: [
          'Video de la mercadería en origen (muestra condiciones)',
          'Video durante la ruta (incidente, tráfico o desvío)',
          'Video del estado de la mercadería al llegar a destino',
          'Otros'
        ],
        pdf: [
          'Cargo firmado por el cliente (en destino)',
          'Formato de recojo (si aplica)',
          'Cargo de entrega en agencia',
          'Acta de entrega (si aplica)',
          'Formato de devolución o rechazo firmado',
          'Documento adicional solicitado por Draeger'
        ]
      },
      filtros: {
        tipo_paquete: "documentos",
        ruc: '',
        razon_social: '',
        cliente_final: '',
        pedido: '',
        guia: '',
        serie_guia: '',
        fecha_inicio: '',
        fecha_fin: '',
        id_modalidades_envio: '',
        id_estados_envio: ''
      },
      comentario: '',
      detalleEnvio: {},
      envios: [],
      pagina: 1,
      porPagina: 25,
      totalPaginas: 1,
      totalEnvios: 0,
      empresas: [
        { id: 1, nombre: 'Empresa A' },
        { id: 2, nombre: 'Empresa B' },
      ],
      tipoUnidades: [
        { id: 3, tipo_unidad: 'Camión 10T' },
        { id: 4, tipo_unidad: 'Camión 20T' },
      ],
      archivos: [],
      nuevoArchivo: {
        tipo: '',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      },
      dragging: false,
      envioSeleccionadoGuias: null,
      showModalGestionGuias: false,
      isUpdatingEstado: false,
      cantidad_bultos_origen: '',
      cantidad_bultos_destino: '',
      estado_bultos_origen: '',
      estado_bultos_destino: '',
      conformidad_entrega: '',
      conformidad_draeger: '',
      showModalArchivoGuia: false,
      detalleGuiaSeleccionado: null,
      tipoArchivoGuia: 'pdf',
      archivoGuia: {
        tipo: 'Cargo firmado por el cliente (en destino)',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      },
      draggingGuia: false,
      loadingSubirArchivoGuia: false,
    }
  },
  watch: {
    '$route.path'() {
      this.limpiarFiltros()
      this.tipoEnvio = this.$route.params.tipo_envio
      if (this.tipoEnvio == 'exclusivos') {
        this.filtros.id_modalidades_envio = 3
      } else if (this.tipoEnvio == 'consolidados') {
        this.filtros.id_modalidades_envio = 2
      } else if (this.tipoEnvio == 'aereos') {
        this.filtros.id_modalidades_envio = 4
      }
      this.buscarEnvios()
    },
  },
  computed: {
    rutaEnvio() {
      switch (this.tipoEnvio) {
        case 'exclusivos':
          return '/envios/exclusivo'
        case 'consolidados':
          return '/envios/consolidado'
        case 'aereos':
          return '/envios/aereo'
        default:
          return '/envios/desconocido'
      }
    },
    opcionesFiltradas() {
      return this.tipoArchivo ? this.opciones[this.tipoArchivo] : [];
    },
    totalPaquetes() {
      return this.paquetes.length
    },
    totalPesoVolumetrico() {
      return this.paquetes.reduce((total, p) => total + p.pesoVolumetrico, 0)
    },
    totalPesoReal() {
      return this.paquetes.reduce((total, p) => total + p.peso, 0)
    },
    costoServicio() {
      return this.paquetes.reduce((total, p) => total + p.costo, 0);
    },
    costoVerificacion() {
      return this.costoServicio * 0.5;
    },

    costoTotal() {
      return Number((this.costoServicio + this.costoVerificacion).toFixed(2));
    }
  },
  mounted() {
    this.buscarEnvios()
    this.getEstadosEnvio()
    this.getCausasConformidad()
    this.getCausasEntregaCompleta()
    this.user = JSON.parse(localStorage.getItem('user'))
  },
  methods: {
    esAdmin() {
      const cargo = this.user?.cargo?.toLowerCase()
      return cargo === 'admin' || cargo === 'admin-draeger'
    },

    esSuperAdmin() {
      return this.user?.cargo?.toLowerCase() === 'admin'
    },
    esSuperAdminOInterno() {
      return this.user?.cargo?.toLowerCase() === 'admin' || this.user?.tipo_usuario == 'interno'
    },
    getTipoEnvioTexto() {
      switch (this.tipoEnvio) {
        case 'exclusivos':
          return 'Exclusivos'
        case 'consolidados':
          return 'Consolidados'
        case 'aereos':
          return 'Aéreos'
        default:
          return 'Desconocido'
      }
    },
    async getCausasConformidad() {
      try {
        const { data } = await axios.get('causas-incidencia')
        this.causasConfomidad = data
        this.isLoading = false;
      } catch (error) {
        console.error('Error al getCausasConformidad', error)
      }
    },
    async getCausasEntregaCompleta() {
      try {
        const { data } = await axios.get('causas-entrega-completa')
        this.causasEntregaCompleta = data
        this.isLoading = false;
      } catch (error) {
        console.error('Error al causasEntregaCompleta', error)
      }
    },
    openEstadoEnvio(item) {
      this.detalleEnvio = { ...item }
      this.nuevoEstado = this.detalleEnvio.id_estados_envio
      this.cantidad_bultos_origen = item.cant_bultos || ''
      this.cantidad_bultos_destino = item.cant_bultos_destino || ''
      this.estado_bultos_origen = item.estado_bultos_origen || ''
      this.estado_bultos_destino = item.estado_bultos_destino || ''
      this.conformidad_entrega = item.conformidad || ''
      this.conformidad_draeger = item.conformidad_draeger || ''
      this.modalEstados = true
    },
    formatFecha(fecha) {
      if (!fecha) return ''
      const [year, month, day] = fecha.split('-')
      return new Date(year, month - 1, day).toLocaleDateString('es-PE', {
        dateStyle: 'short',
      })
    },
    editarEnvio(envio) {
      this.$router.push(`/editar-envio/${envio.id_envio}`)
    },
    mostrarDetalle(item) {
      this.modalDetalle = true
      this.detalleEnvio = { ...item }
    },
    abrirGestionarModal(item) {
      this.detalleEnvio = item;
      console.log("detalleEnvio", this.detalleEnvio)
      this.modalGestionANW = true
    },
    cerrarDetalle() {
      this.modalDetalle = false
    },
    obtenerNombreEmpresa(id) {
      return this.empresas.find((e) => e.id === id)?.nombre || 'No especificado'
    },
    obtenerTipoUnidad(id) {
      return (
        this.tipoUnidades.find((t) => t.id === id)?.tipo_unidad ||
        'No especificado'
      )
    },
    async buscarEnvios() {
      this.isLoading = true;
      this.filtros.tipo_paquete = "mercaderia";
      if (this.tipoEnvio == 'exclusivos') {
        this.filtros.id_modalidades_envio = 3
      } else if (this.tipoEnvio == 'consolidados') {
        this.filtros.id_modalidades_envio = 2
      } else if (this.tipoEnvio == 'aereos') {
        this.filtros.id_modalidades_envio = 4
      }
      try {
        const { data } = await axios.get('envios', { params: { ...this.filtros, page: this.pagina } })
        // Si la página quedó fuera de rango (p. ej. al eliminar el último envío de la última página), ir a la última
        if (data.data.length === 0 && data.total > 0 && this.pagina > data.last_page) {
          this.pagina = data.last_page
          return this.buscarEnvios()
        }
        this.envios = data.data
        this.totalPaginas = data.last_page
        this.totalEnvios = data.total
      } catch (error) {
        console.error('Error al buscar envíos', error)
      } finally {
        this.isLoading = false;
      }
    },
    aplicarFiltros() {
      this.pagina = 1
      this.buscarEnvios()
    },
    cambiarPagina(n) {
      this.pagina = n
      this.buscarEnvios()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    async eliminarEnvio(envio) {
      const confirmacion = await Swal.fire({
        title: '¿Estás seguro?',
        text: `Vas a eliminar el envío ${envio.rastreo || ''}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
      });

      if (confirmacion.isConfirmed) {
        try {
          await axios.delete(`/envios/${envio.id_envio}`);

          await Swal.fire({
            icon: 'success',
            title: 'Eliminado',
            text: 'El envío fue eliminado correctamente.',
            timer: 1500,
            showConfirmButton: false,
          });

          this.buscarEnvios();

        } catch (error) {
          console.error(error);
          
          let errorMessage = 'Hubo un problema al eliminar el envío.';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
          });
        }
      }
    },
    async buscarPrecioConsolidado() {
      try {
        let url = `precio-consolidado/peso_volumen/${this.formGestion.id_distrito_destinatario}`
        const response = await axios.get(url)
        const data = response.data
        this.costoPorKg = data.costo
      } catch (error) {
        console.error(`Error al cargar precios`, error)
      }
    },
    calcularCosto() {
      this.pesoVolumetrico = (this.alto * this.ancho * this.largo) / 5000
      let mayorPeso = Math.max(this.pesoReal, this.pesoVolumetrico)
      this.costoPaquete = parseFloat((mayorPeso * this.costoPorKg).toFixed(2))
    },
    async aceptarEnvio() {
      await this.actualizarEnvio('aceptar')
    },

    async rechazarEnvio() {
      await this.actualizarEnvio('rechazar')
    },
    agregarPaquete() {
      if (
        !this.nombrePaquete ||
        !this.alto ||
        !this.ancho ||
        !this.largo ||
        !this.pesoReal
      ) {
        alert('Completa todos los campos antes de agregar el paquete.')
        return
      }

      this.paquetes.push({
        nombre: this.nombrePaquete,
        alto: this.alto,
        ancho: this.ancho,
        largo: this.largo,
        peso: this.pesoReal,
        pesoVolumetrico: this.pesoVolumetrico,
        costo: this.costoPaquete,
      })

      // Limpiar los campos
      this.nombrePaquete = ''
      this.alto = ''
      this.ancho = ''
      this.largo = ''
      this.pesoReal = ''
      this.pesoVolumetrico = 0
      this.costoPaquete = 0
    },
    eliminarPaquete(index) {
      this.paquetes.splice(index, 1)
    },
    async getEstadosEnvio() {
      this.isLoading = true;
      const { data } = await axios.get('estados-envio')
      this.estadosEnvio = data
      // if (this.user.cargo == "admin-draeger") {
      //   this.estadosEnvio = this.estadosEnvio.filter(item => item.id == 16)
      // }
      this.isLoading = false;
    },
    async actualizarEnvio(accion) {
      try {
        await axios.get(`${accion}-envio/${this.detalleEnvio.id_envio}`)
        this.cerrarDetalle()
        this.buscarEnvios()
        Swal.fire({
          icon: 'success',
          title: 'Envío Actualizado',
          text: 'Los datos se han actualizado correctamente.',
        })
      } catch (error) {
        console.error(`Error al ${accion} envío`, error)
      }
    },
    getBadgeClass(estado) {
      const badgeMap = {
        1:  'badge-estado-solicitud',     // Solicitud Recibida
        2:  'badge-estado-aprobada',      // Aprobada
        3:  'badge-estado-rechazada',     // Rechazada
        4:  'badge-estado-espera',        // En espera
        5:  'badge-estado-recojo-curso',  // Recojo en curso
        6:  'badge-estado-recojo-conf',   // Recojo confirmado
        7:  'badge-estado-embarque',      // Embarque/Despacho
        8:  'badge-estado-traslado',      // Traslado en curso
        9:  'badge-estado-llegada',       // Llegada a destino
        10: 'badge-estado-entrega-curso', // Entrega en curso
        11: 'badge-estado-entregado',     // Entregado
        12: 'badge-estado-cargo-pdf',     // Cargo PDF
        13: 'badge-estado-cargo-fisico',  // Cargo Físico Confirmado
        14: 'badge-estado-observado',     // Servicio Observado
        15: 'badge-estado-reprogramado',  // Reprogramado
        16: 'badge-estado-cancelado',     // Cancelado
      };

      return `badge ${badgeMap[estado] || 'badge-estado-solicitud'} breakable-badge`;
    },

    limpiarFiltros() {
      Object.keys(this.filtros).forEach(
        (key) =>
          (this.filtros[key] = key === 'id_modalidades_envio' ? '' : ''),
      )
      this.pagina = 1
      this.buscarEnvios()
    },

    abrirCargarArchivosModal(envio) {
      this.envioId = envio.id_envio
      this.cargarArchivos(envio.id_envio)
      this.showModalArchivos = true
    },
    seleccionarArchivo(event) {
      this.procesarArchivo(event.target.files[0])
    },
    abrirExplorador() {
      this.$refs.fileInput.click()
    },
    soltarArchivo(event) {
      this.dragging = false
      this.procesarArchivo(event.dataTransfer.files[0])
    },
    procesarArchivo(file) {
      if (file) {
        this.nuevoArchivo = {
          ...this.nuevoArchivo,
          archivo: file,
          nombre: file.name,
          url: URL.createObjectURL(file),
        }
      }
    },
    async exportarExcel() {
      try {
        const response = await axios.get('/exportar-envios', {
          params: this.filtros,
          responseType: 'blob'
        });

        // Generar nombre dinámico: provincia_mercaderia_YYYYmmddHHMMss.xlsx
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const fileName = `provincia_mercaderia_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.xlsx`;

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error al exportar:', error);
      }
    },

    async exportarReportePdf() {
      const errorRango = validarRangoFechas(this.filtros.fecha_inicio, this.filtros.fecha_fin, LIMITE_REPORTE_RUTA);
      if (errorRango) {
        Swal.fire({ icon: 'info', title: 'Ajusta el rango de fechas', text: errorRango });
        return;
      }
      try {
        const response = await axios.get('/envios-reporte', {
          params: this.filtros,
          responseType: 'blob'
        });

        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const fileName = `r_ruta_co_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.pdf`;

        const blob = new Blob([response.data], {
          type: 'application/pdf'
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error al exportar reporte PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'No se pudo generar el reporte',
          text: await mensajeErrorDescarga(error, 'Ocurrió un error al generar el archivo. Intenta nuevamente.'),
        });
      }
    },

    async guardarGestion() {
      try {
        const resultado = await this.$refs.shippingANWRef.submitDesdePadre();
        console.log('Resultado desde el hijo:', resultado);
      } catch (error) {
        console.error('Error al guardar desde el hijo:', error);
      }
    },

    async gestionEstado() {
      if (this.isUpdatingEstado) {
        return
      }

      this.isUpdatingEstado = true
      let data = {
        id_envio: this.detalleEnvio.id_envio,
        id_estados_envio: this.nuevoEstado
      }
      if (this.nuevoEstado == 19) {
        data.conformidad_draeger = this.conformidad_draeger;
      }
      if (this.nuevoEstado == 4 || this.nuevoEstado == 6) {
        data.cantidad_bultos_origen = this.cantidad_bultos_origen;
        data.estado_bultos_origen = this.estado_bultos_origen;
      }
      if (this.nuevoEstado == 11) {
        data.cantidad_bultos_destino = this.cantidad_bultos_destino;
        data.estado_bultos_destino = this.estado_bultos_destino;
        data.conformidad = this.conformidad_entrega;
      }
      try {
        await axios.post(`estado-envio`, data)
        await this.agregarArchivo();
        this.buscarEnvios()
        this.cargarArchivos(this.detalleEnvio.id_envio)
        Swal.fire({
          icon: 'success',
          title: 'Estado Actualizado',
          text: 'El estado se ha actualizado correctamente.',
        })
        this.modalEstados = false
      } catch (error) {
        console.error(`Error al actualizar el estado del envío`, error)
      } finally {
        this.isUpdatingEstado = false
      }
    },

    async agregarArchivo() {

      const formData = new FormData()
      formData.append('envio_id', this.detalleEnvio.id_envio)
      formData.append('tipo', this.nuevoArchivo.tipo)
      formData.append('archivo', this.nuevoArchivo.archivo)
      formData.append('comentario', this.nuevoArchivo.comentario)
      formData.append('id_estados_envio', this.nuevoEstado)

      try {
        const { data } = await axios.post('/subir-archivo', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        this.archivos.push(data)
        this.nuevoArchivo = {
          tipo: '',
          archivo: null,
          nombre: '',
          comentario: '',
        }

      } catch (error) {
        console.error('Error al subir archivo', error)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo subir el archivo. Inténtelo de nuevo.',
        })
      }
    },
    async cargarArchivos(envioId) {
      try {
        const { data } = await axios.get(`/archivos/${envioId}`)
        this.archivos = data
      } catch (error) {
        console.error('Error al obtener archivos', error)
      }
    },
    verArchivo(archivo) {
      window.open(archivo.url, '_blank')
    },
    verArchivoGuia(url) {
      if (!url) {
        Swal.fire({
          icon: 'warning',
          title: 'Archivo no disponible',
          text: 'No se encontró la URL del archivo de guía.',
        })
        return
      }

      window.open(url, '_blank')
    },
    async eliminarArchivo(id) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      })

      if (result.isConfirmed) {
        try {
          await axios.delete(`/eliminar-archivo/${id}`)
          this.cargarArchivos(this.envioId)

          Swal.fire({
            icon: 'success',
            title: 'Eliminado',
            text: 'El archivo ha sido eliminado correctamente.',
            confirmButtonText: 'OK',
          })
        } catch (error) {
          console.error('Error al eliminar archivo', error)

          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo eliminar el archivo.',
            confirmButtonText: 'OK',
          })
        }
      }
    },

    esImagen(nombre) {
      return /\.(jpg|jpeg|png|gif)$/i.test(nombre)
    },
    abrirGestionGuiasModal(envio) {
      this.envioSeleccionadoGuias = envio;
      this.showModalGestionGuias = true;
    },
    // Datos del documento para el modal de subida (solo los que tienen valor)
    referenciasGuia(detalle) {
      return [
        { label: 'Guía remitente', valor: detalle.guia_remitente },
        { label: 'Guía transportista', valor: detalle.guia_transportista },
        { label: 'N° pedido', valor: detalle.nro_pedido },
        { label: 'Orden de compra', valor: detalle.orden_compra },
        { label: 'Factura', valor: detalle.numero_factura },
      ].filter(ref => ref.valor)
    },
    subirArchivoGuia(detalle) {
      Swal.fire({
        title: '¿Subir archivo de guía?',
        text: 'Solo puedes subir si ya actualizaste el estado a CARGO PDF SUBIDO.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.detalleGuiaSeleccionado = detalle;
          this.limpiarArchivoGuia();
          this.showModalArchivoGuia = true;
        }
      });
    },
    cerrarModalArchivoGuia() {
      this.showModalArchivoGuia = false;
      this.detalleGuiaSeleccionado = null;
      this.limpiarArchivoGuia();
    },
    limpiarArchivoGuia() {
      this.archivoGuia = {
        tipo: 'Cargo firmado por el cliente (en destino)',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      };
      this.tipoArchivoGuia = 'pdf';
      this.draggingGuia = false;
    },
    seleccionarArchivoGuia(event) {
      this.procesarArchivoGuia(event.target.files[0]);
    },
    abrirExploradorGuia() {
      this.$refs.fileInputGuia.click();
    },
    soltarArchivoGuia(event) {
      this.draggingGuia = false;
      this.procesarArchivoGuia(event.dataTransfer.files[0]);
    },
    procesarArchivoGuia(file) {
      if (file) {
        this.archivoGuia = {
          ...this.archivoGuia,
          archivo: file,
          nombre: file.name,
          url: URL.createObjectURL(file),
        };
      }
    },
    async guardarArchivoGuia() {
      this.loadingSubirArchivoGuia = true;
      if (!this.archivoGuia.archivo) {
        Swal.fire({
          icon: 'warning',
          title: 'Campo requerido',
          text: 'Debes seleccionar un archivo.',
        });
        this.loadingSubirArchivoGuia = false;
        return;
      }

      const formData = new FormData();
      formData.append('envio_id', this.envioSeleccionadoGuias.id_envio);
      formData.append('tipo', this.archivoGuia.tipo);
      formData.append('archivo', this.archivoGuia.archivo);
      formData.append('comentario', this.archivoGuia.comentario);
      formData.append('id_estados_envio', 12);
      formData.append('id_envio_detalle', this.detalleGuiaSeleccionado.id);

      try {
        await axios.post('/subir-archivo', formData);
        await this.buscarEnvios();

        const envioActualizado = this.envios.find(
          (envio) => envio.id_envio === this.envioSeleccionadoGuias.id_envio,
        );
        if (envioActualizado) {
          this.envioSeleccionadoGuias = envioActualizado;
        }

        Swal.fire({
          icon: 'success',
          title: 'Archivo subido',
          text: 'El archivo se ha subido correctamente.',
        });

        this.cerrarModalArchivoGuia();
      } catch (error) {
        let mensaje = '';

        if (error.response) {
          mensaje = JSON.stringify(error.response.data);
        } else if (error.request) {
          mensaje = 'No hubo respuesta del servidor';
        } else {
          mensaje = error.message;
        }

        Swal.fire({
          icon: 'error',
          title: 'Error real',
          html: `<pre style="text-align:left">${mensaje}</pre>`,
          width: 600,
        });
      } finally {
        this.loadingSubirArchivoGuia = false;
      }
    },
  },
}
</script>

<style scoped>
.modal.fade.show {
  display: block;
}

.modal.show {
  background: rgba(0, 0, 0, 0.5);
}


.badge {
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 5px;
  line-height: 1.2;
}

.breakable-badge {
  white-space: normal;
  word-break: break-word;
}

.table-font-small {
  font-size: 0.75rem;
}

.table {
  width: 100%;
}

.table th,
.table td {
  white-space: normal;
  /* Permite saltos de línea */
  /* Oculta el exceso de contenido */
  text-overflow: ellipsis;
  /* Mantiene los puntos suspensivos si el contenido es demasiado grande */
  word-wrap: break-word;
  /* Rompe palabras largas si es necesario */
  overflow-wrap: break-word;
  /* Alternativa moderna */
  text-align: center;
  vertical-align: middle;
}




/* Anchos de columna: los reparte el navegador según el contenido (ver estándar en admin-tables.css) */
.table-merc-list {
  width: 100%;
}

.table-gestion-guias {
  table-layout: fixed;
  width: 100%;
}

.table-gestion-guias th,
.table-gestion-guias td {
  font-size: 0.75rem;
  vertical-align: middle;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  padding: 0.45rem;
}

.table-gestion-guias th:nth-child(1),
.table-gestion-guias td:nth-child(1) {
  width: 14%;
}

.table-gestion-guias th:nth-child(2),
.table-gestion-guias td:nth-child(2) {
  width: 14%;
}

.table-gestion-guias th:nth-child(3),
.table-gestion-guias td:nth-child(3) {
  width: 10%;
}

.table-gestion-guias th:nth-child(4),
.table-gestion-guias td:nth-child(4) {
  width: 12%;
}

.table-gestion-guias th:nth-child(5),
.table-gestion-guias td:nth-child(5) {
  width: 10%;
}

.table-gestion-guias th:nth-child(6),
.table-gestion-guias td:nth-child(6) {
  width: 14%;
}

.table-gestion-guias th:nth-child(7),
.table-gestion-guias td:nth-child(7) {
  width: 14%;
}

.table-gestion-guias th:nth-child(8),
.table-gestion-guias td:nth-child(8) {
  width: 12%;
  text-align: center;
}

.table-gestion-guias td:nth-child(8) .btn {
  width: 100%;
  white-space: normal;
  line-height: 1.1;
  padding: 0.35rem 0.4rem;
}

.table-gestion-guias-wrapper {
  overflow-x: hidden;
}

.dropdown-menu {
  min-width: 180px;
}

.dropdown-item i {
  margin-right: 8px;
}

.custom-dropdown {
  position: absolute !important;
  /* Permite que se desplace sobre otras filas */
  z-index: 1050 !important;
  /* Asegura que esté sobre otros elementos */
  left: auto !important;
  /* Evita que se recorte en la tabla */
  right: 0 !important;
  /* Alinea correctamente */
}

.table-responsive {
  overflow: visible !important;
  /* Permite que el dropdown no se esconda */
}

.dropdown-menu.show {
  position: absolute !important;
  z-index: 1050 !important;
  will-change: transform;
}

.dropzone {
  border: 2px dashed #007bff;
  padding: 20px;
  text-align: center;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s;
}

.dropzone:hover,
.dropzone.drop-hover {
  background: rgba(0, 123, 255, 0.1);
}

.dropzone-content i {
  color: #007bff;
}

.dropzone-preview img {
  max-width: 100px;
  margin-top: 10px;
}

.swal2-container {
  z-index: 9999 !important;
}



.modal {
  z-index: 90;
}

.textarea-small {
  height: 100px;
}

#modalGestionANW label {
  font-size: 0.75rem;
}

/* Detalle */
</style>

<style>
/* Estados de envío — colores únicos por estado (global) */
.badge-estado-solicitud     { background-color: #6c757d; color: #fff; } /* Solicitud Recibida  - gris */
.badge-estado-aprobada      { background-color: #198754; color: #fff; } /* Aprobada            - verde */
.badge-estado-rechazada     { background-color: #dc3545; color: #fff; } /* Rechazada           - rojo */
.badge-estado-espera        { background-color: #ffc107; color: #000; } /* En espera           - amarillo */
.badge-estado-recojo-curso  { background-color: #0dcaf0; color: #000; } /* Recojo en curso     - cian */
.badge-estado-recojo-conf   { background-color: #20c997; color: #fff; } /* Recojo confirmado   - turquesa */
.badge-estado-embarque      { background-color: #fd7e14; color: #fff; } /* Embarque/Despacho   - naranja */
.badge-estado-traslado      { background-color: #6610f2; color: #fff; } /* Traslado en curso   - índigo */
.badge-estado-llegada       { background-color: #0d6efd; color: #fff; } /* Llegada a destino   - azul */
.badge-estado-entrega-curso { background-color: #6f42c1; color: #fff; } /* Entrega en curso    - morado */
.badge-estado-entregado     { background-color: #0f5132; color: #fff; } /* Entregado           - verde oscuro */
.badge-estado-cargo-pdf     { background-color: #084298; color: #fff; } /* Cargo PDF           - azul oscuro */
.badge-estado-cargo-fisico  { background-color: #087990; color: #fff; } /* Cargo Físico Conf.  - azul petróleo */
.badge-estado-observado     { background-color: #842029; color: #fff; } /* Servicio Observado  - rojo oscuro */
.badge-estado-reprogramado  { background-color: #e65c00; color: #fff; } /* Reprogramado        - naranja oscuro */
.badge-estado-cancelado     { background-color: #b02a37; color: #fff; } /* Cancelado           - carmesí */
</style>
